interface MetaRobotsProperties {
  readonly noindex?: boolean;
  readonly nofollow?: boolean;
}

export function metaRobotsValue(config: MetaRobotsProperties): string {
  return Object.entries(config)
    .reduce((acc: string[], [key, val]) => {
      acc.push(val ? key : key.substring(2));
      return acc;
    }, [])
    .join(', ');
}
